// extracted by mini-css-extract-plugin
module.exports = {"container":"printer_container__1xPqp","body":"printer_body__3AkXy","bg-footer":"printer_bg-footer__2UUC7","image-bg":"printer_image-bg__2bl1s"};